import moment from 'moment';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useBookingPage = create(
        (set) => ({
            register: {
                firstName:"",
                lastName:"",
                birthday:"",
                gender:"",
                contactNumber:"",
                email:"",
                restaurant:"",
                branch:"",
                address:"",
                province:"",
                district:"",
                subDistrict:"",
                postCode:"",
                pdpa:"",
                marketing:"",
                hasBranch:""
            },
            setRegister: async (payload) =>{
                set((state) => ({
                    register: {...state.register, ...payload}
                }))
            }

        })
);

export default useBookingPage;